// Copyright (c) 2020-23, iPivot, Corp.
'use strict'

import { config, library } from '@fortawesome/fontawesome-svg-core'
import { faExclamationTriangle, faLock, faUser } from '@fortawesome/free-solid-svg-icons'
config.autoAddCss = false
library.add(faExclamationTriangle, faLock, faUser)
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import i18next from 'i18next'
import LngDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { Suspense } from 'react'
import { Spinner } from 'react-bootstrap'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import { initReactI18next } from 'react-i18next'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
__webpack_nonce__ = window.NONCE //eslint-disable-line no-undef

import ErrorBoundaryFallback from 'js/components/ErrorBoundaryFallback'
import Login from 'js/components/login/Login'

import { UiContextProvider } from 'js/contexts/uiContext'

import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { GlobalStyles } from 'js/themes/GlobalStyles'
import { useTheme } from 'js/themes/useTheme'


i18next
    .use(LngDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath: '/dist/locales/{{lng}}/{{ns}}.json',
        },
        detection: {
            order: ['navigator'],
        },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react
        },
    })

const queryClient = new QueryClient()

const LoginApp = () => {
    const theme = useTheme(false)

    if (Object.keys(theme).length > 0) {
        return (
            <>
                <Suspense
                    fallback={
                        <div className="d-flex align-items-center">
                            <Spinner />
                            <span className="ms-2">Loading</span>
                        </div>
                    }
                >
                    <ThemeProvider theme={theme}>
                        <GlobalStyles />
                        <QueryClientProvider client={queryClient}>
                            <ErrorBoundary
                                FallbackComponent={ErrorBoundaryFallback}
                                onReset={details => {
                                    // Reset the state of your app so the error doesn't happen again
                                    // console.log(details)
                                }}
                            >
                                <UiContextProvider>
                                    <BrowserRouter basename="/login">
                                        <Routes>
                                            <Route path="*" element={<Login />} />
                                        </Routes>
                                    </BrowserRouter>
                                </UiContextProvider>
                            </ErrorBoundary>
                        </QueryClientProvider>
                    </ThemeProvider>
                </Suspense>
            </>
        )
    } else {
        return (
            <div className="d-flex align-items-center">
                <Spinner />
                <span className="ms-2">Loading</span>
            </div>
        )
    }
}

const container = document.getElementById('enc')
const root = createRoot(container)
root.render(<LoginApp />)
